import React, { useState, useEffect } from 'react';

const ImageSequenceComponent = ({ shouldChange, imageSet, alternateImageSet, useAlternateSet }) => {
  const [imageIndex, setImageIndex] = useState(0);
  const selectedImageSet = useAlternateSet ? alternateImageSet : imageSet;

  useEffect(() => {
    let interval;
    console.log(":");
    console.log(imageIndex);
    if (shouldChange) {
      interval = setInterval(() => {
        if (imageIndex === selectedImageSet.length - 1) {
          clearInterval(interval); // Stop the interval if the sequence reaches the last image
        } else {
          setImageIndex((prevIndex) => prevIndex + 1);
        }
      }, 50);
    }

    return () => clearInterval(interval);
  }, [shouldChange, imageIndex, selectedImageSet.length]);

  return (
    <div>
      <img src={selectedImageSet[imageIndex]} alt={`Image ${imageIndex + 1}`} />
    </div>
  );
};

export default ImageSequenceComponent;
